var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21",
    width: 24,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 21,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAMAAABrN94UAAAAAXNSR0IB2cksfwAAAPBQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ZmikqQAAAFB0Uk5T0+ztugDv/9LH3q8JCgghJR34w+6/1qkFFGWXjk4BKC0mAjbgsA3i/NgDE+OY8OVjYYP79yDEp5RgS4qLD9T+PUbB1+molo/moBtDORKNnp1mNqrTAAAAt0lEQVR4nHWR1RLCQAxFFwhBiru7u7u78/9/w0J32mmA83pmcm8SxnRa9Ab4wIxIMAlhthCsQkg2gl0I+ANzOAkuISxugkcI779WPj8hIERQixpOyoTCkWgs/haJpEIqDZnsOyaX56JQVCiVK1W5QI2LutqnAU3EbKvdwW4PmLWvMIAh4gjAgDgm4RPEKczmuFgSseID1xvEbZ6I8k5OK+7pHtKBn+jI1enr7OfL9XZHfPz+R+QJLwL1HElBNy40AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSearch);
export default __webpack_public_path__ + "static/media/saveSearch.aea6a2bf7c76e402c2fcd757ff2c6715.svg";
export { ForwardRef as ReactComponent };